module.exports = __webpack_public_path__ + "img/25.06d2c6d1.jpg";